import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const api = axios.create({
    baseURL: config.baseUrl,
});

// Interceptor para agregar el token a todas las requests
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Obtener todos los participantes
export const getParticipantes = async (project) => {
  try {
    const response = await api.get('/api/getParticipant', {
      params: { project }
    });

    return {
      status: response.status,
      data: response.data.Participantes
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: "Error fetching participants"
    };
  }
};


// Obtener un participante por ID
export const getParticipanteById = async (oid) => {
    try {
        const response = await api.get(`/api/getParticipant/${oid}`);
        return {
            status: response.status,
            data: response.data.participante
        };
    } catch (error) {
        console.error('Error fetching participant by ID:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching participant'
        };
    } 
};

// Crear un nuevo participante
export const createParticipante = async (participanteData) => {
    try {
        const response = await api.post('/api/createParticipante', participanteData);
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        console.error('Error creating participant:', error);
        console.error('Error response:', error.response?.data);

        return {
            status: error.response ? error.response.status : 500,
            message: error.response?.data?.message || 'Error creating participant',
            details: error.response?.data
        };
    }
};

// Actualizar un participante
export const updateParticipante = async (oid, participanteData, oid_participante_proyecto) => {
    try {
        // Agregamos oid_participante_proyecto al body
        const data = {
            ...participanteData,
            oidParticipanteProyecto: oid_participante_proyecto
        };

        const response = await api.put(`/api/updateParticipante/${oid}`, data);
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        console.error('Error updating participant:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error updating participant',
            details: error.response?.data
        };
    }
};


// Inactivar (eliminar) un participante
export const deleteParticipante = async (oid) => {
    try {
        const response = await api.delete(`/api/removeParticipante/${oid}`);
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        console.error('Error deleting participant:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error deleting participant'
        };
    }
};

// Obtener participantes por proyecto
export const getParticipantesByProyecto = async (proyectoData) => {
    try {
        const response = await api.post('/api/getParticipantesxProyectos', proyectoData);
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        console.error('Error fetching participants by project:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching participants by project'
        };
    }
};

// Obtener todos los catálogos para formularios
export const getCatalogosParticipante = async () => {
    try {
        const response = await api.get('/api/getDataParticipante');
        return {
            status: response.status,
            data: response.data.catalogos
        };
    } catch (error) {
        console.error('Error fetching catalogs:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching catalogs'
        };
    }
};

// Obtener municipios por departamento
export const getMunicipiosByDepartamento = async (oidDepto) => {
    try {
        const response = await api.get(`/api/catalogos/municipios?departamentoId=${oidDepto}`);
        return {
            status: response.status,
            data: response.data.municipios
        };
    } catch (error) {
        console.error('Error fetching municipalities:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching municipalities'
        };
    }
};

const participantesService = {
    getParticipantes,
    getParticipanteById,
    createParticipante,
    updateParticipante,
    deleteParticipante,
    getParticipantesByProyecto,
    getCatalogosParticipante,
    getMunicipiosByDepartamento
};

export default participantesService;